import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="py-32 text-center">
      <div className="max-w-2xl mx-auto px-6">
        <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
          404
        </div>
        <h1 className="mt-4 font-serif text-4xl md:text-6xl text-slate-900 tracking-tight">
          Page not found.
        </h1>
        <p className="mt-4 text-slate-600">
          The page you are looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full hover:bg-blue-800"
        >
          Return to Home
        </Link>
      </div>
    </section>
  );
}
